import React, { ReactElement } from 'react';
import { Diagnosis } from '../../types/diagnosis/diagnosis.type';
import { FiEye, FiClock, FiGithub } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import DiagnosisCardLoader from './loader/dianosis-card.loader';
import Error from '../error';
import moment from 'moment';

export default function DiagnosisListCard(props: {
	diagnosis: Diagnosis | null;
	fetchFn?: Function;
}): ReactElement {
	return (
		<Link to={props.diagnosis ? `/diagnosis/item/${props.diagnosis.id}` : ''}>
			<div className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition-shadow">
				{props.diagnosis ? (
					<>
						<h3 className="text-xl font-bold text-gray-800">{props.diagnosis.title}</h3>
						<p className="text-gray-500">{props.diagnosis.sub_title}</p>
						<p className="text-sm text-gray-400 mt-2">{props.diagnosis.description}</p>
					</>
				) : (
					<div className="animate-pulse">
						<div className="h-6 bg-gray-300 rounded mb-2"></div>
						<div className="h-4 bg-gray-300 rounded"></div>
					</div>
				)}
			</div>
		</Link>
	);
}
